import React, { useEffect } from 'react'
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { useNavigate, useLocation} from 'react-router-dom';
import { useContext } from 'react';
import { Usercontext } from '../App';

export default function LoginWrapper({children}) {
    
    const context = useContext(Usercontext)

    const navigate = useNavigate();

      useEffect(() => {
    firebase.auth().onAuthStateChanged(async(user)=>{
      if(user)
      {
        const {email,displayName,uid} = user
        if((await firebase.firestore().collection("Admin").doc(uid).get()).exists)
        {
          console.log("Admin Data")
          context.setuserdata(()=>({email, displayName, uid, isAdmin : true}))          
        }  
        else{
          console.log("Normal User Data")
          context.setuserdata(()=>({email, displayName, uid,isAdmin : false }))
        }
        // console.log(uid,email,displayName)
      }
      else 
      {
        context.setuserdata(null);
        navigate("/signuplogin", {replace:true})
      }
    })
  }, [navigate]);
  
    return (


    
    <>


    {
        children}


    </>
  )
}
